/** 件数 API のカテゴリキー全体。BE `equipment-alert-category.ts` の検証集合とキーを同期すること。 */
const EQUIPMENT_ALERT_COUNT_CATEGORY_KEYS = ['COLLECTION_DUE', 'INVENTORY_CHECK_DUE', 'LENDING_DUE', 'PLACEMENT_DUE', 'REPLACEMENT_DUE', 'SHORTAGE'] as const;
export type EquipmentAlertCountCategoryKey = (typeof EQUIPMENT_ALERT_COUNT_CATEGORY_KEYS)[number];

// 段階的リリース: 現在は REPLACEMENT_DUE のみ実装。
// 他カテゴリ（COLLECTION_DUE, INVENTORY_CHECK_DUE, LENDING_DUE, PLACEMENT_DUE, SHORTAGE）は
// バックエンド API 実装後に追加予定。翻訳キーは全 6 カテゴリ分を先行定義済み。
export const ALERT_CATEGORY_KEYS = ['REPLACEMENT_DUE'] as const satisfies readonly EquipmentAlertCountCategoryKey[];
export type AlertCategoryKey = (typeof ALERT_CATEGORY_KEYS)[number];